import WalletConnectProvider from "@walletconnect/web3-provider";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import CoinbaseWalletSDK from "@coinbase/wallet-sdk";
import { WalletConnectConnector } from "@wagmi/core/connectors/walletConnect";
import { mainnet, optimism, polygon } from "@wagmi/core/chains";

import Web3Modal from "web3modal";
import Contract from "web3-eth-contract";
import Constants from "../config";
import BigNumber from "bignumber.js";

const Web3 = require("web3");

let walletProvider = null;
let walletAddress = "";

// const connector = await EthereumProvider.init({
//   projectId: "fdb8164b4aa07b46f14e131f5c7c5903", // required
//   chains: [1], // required
//   showQrModal: true, // requires @walletconnect/modal
//   relayUrl: "wss://relay.walletconnect.com",
//   metadata: {
//     name: "RenQ Earn",
//     description: "Renq staking and farming Dapp",
//     url: "https://renq.io",
//     icons: ["https://walletconnect.com/walletconnect-logo.png"],
//   },
// });

// const connector = new WalletConnectConnector({
//   options: {
//     projectId: "fdb8164b4aa07b46f14e131f5c7c5903",
//     showQrModal: true,
//     chains: [mainnet],
//   },
// });

// connector.connect();

// console.log(connector, "provider");

const providerOptions = {
  coinbasewallet: {
    package: CoinbaseWalletSDK,
    options: {
      appName: "Renq Stake",
      infuraId: "460f40a260564ac4a4f4b3fffb032dad",
    },
  },
  // walletconnect: {
  //   package: connector, // required
  //   options: {
  //     infuraId: "460f40a260564ac4a4f4b3fffb032dad", // required
  //     bridge: "https://bridge.walletconnect.org",
  //   },
  //   rpc: {
  //     1: "https://eth.llamarpc.com",
  //     5: "https://rpc.goerli.eth.gateway.fm",
  //   },
  // },
  // trustwallet: {
  //   package: WalletConnectProvider, // required
  //   options: {
  //     infuraId: "460f40a260564ac4a4f4b3fffb032dad", // required
  //     bridge: "https://bridge.walletconnect.org",
  //   },
  //   rpc: {
  //     1: "https://eth.llamarpc.com",
  //     5: "https://rpc.goerli.eth.gateway.fm",
  //   },
  // },
};

const web3Modal = new Web3Modal({
  network: "mainnet", // optional
  cacheProvider: false, // optional
  disableInjectedProvider: false,
  providerOptions, // required
});

export const getBNBDecimals = () => {
  return 18;
};

export const getWalletProvider = () => {
  return walletProvider;
};
export const getWalletAddres = () => {
  return walletAddress;
};

export const getAccountInfo = async () => {
  try {
    // const provider = localStorage.getItem("WEB3_CONNECT_CACHED_PROVIDER");
    // Check if browser is running Metamask
    let web3;
    if (window.ethereum) {
      web3 = new Web3(window.ethereum);
    } else if (window.web3) {
      web3 = new Web3(window.web3.currentProvider);
    }

    // Check if User is already connected by retrieving the accounts
    const accounts = await web3.eth.getAccounts();

    return {
      address: accounts[0],
      status: "",
    };
  } catch (err) {
    return {
      address: "",
      status: err.message,
    };
  }
};

export const setupNetwork = async () => {
  const provider = window.ethereum;
  if (provider) {
    const chainId = Constants.ChainID;
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${chainId.toString(16)}`,
            // chainName: Constants.CHAIN_NAME[chainId],
            // nativeCurrency: Constants.NATIVE_CURRENCY[chainId],
            // rpcUrls: [Constants.Node],
            // blockExplorerUrls: [Constants.BASE_BSC_SCAN_URLS[chainId]],
          },
        ],
      });
      return true;
    } catch (error) {
      console.error("Failed to setup the network in Metamask:", error);
      return false;
    }
  } else {
    console.error(
      "Can't setup the BSC network on metamask because window.ethereum is undefined"
    );
    return false;
  }
};

export const connectWallet = async () => {
  try {
    await web3Modal.clearCachedProvider();
    const provider = await web3Modal.connect();
    window.web3 = new Web3(provider);
    // window.currentProvider = window.ethereum;

    window.web3.eth.extend({
      methods: [
        {
          name: "chainId",
          call: "eth_chainId",
          outputFormatter: window.web3.utils.hexToNumber,
        },
      ],
    });

    const chainId = await window.web3.eth.chainId();
    if (chainId !== Constants.ChainID) {
      //56: mainnet, 97: testnet
      const res = await setupNetwork();
      if (!res) {
        return {
          address: "",
          status: "Add network",
        };
      }
    }

    provider.on("chainChanged", (chainId) => {
      setupNetwork();
    });

    const accounts = await window.web3.eth.getAccounts();
    const address = accounts[0];

    window.localStorage.setItem(Constants.WalletLocalStorageKey, address);

    walletProvider = provider;
    walletAddress = address;
    //console.log("Connected WalletAddress: ", walletAddress)
    if (accounts.length > 0) {
      return {
        address: walletAddress,
        status: "Success",
      };
    } else {
      return {
        address: "",
        status: "Connect to wallet",
      };
    }
  } catch (err) {
    return {
      address: "",
      status: err.message,
    };
  }
};
export const isWalletConnected = () => {
  if (walletProvider !== null && walletProvider !== undefined) return true;
  return false;
};

export const disconnectWallet = async () => {
  //console.log("IsConneted: ", isWalletConnected())
  //console.log("WalletProvider: ", walletProvider)
  await web3Modal.clearCachedProvider();
  if (
    walletProvider?.disconnect &&
    typeof walletProvider.disconnect === "function"
  ) {
    await walletProvider.disconnect();
  }
  window.localStorage.removeItem(Constants.WalletLocalStorageKey);
  walletProvider = null;
};

const ContractUtils = {
  getBNBDecimals,
  getWalletProvider,
  getWalletAddres,
  connectWallet,
  disconnectWallet,
  isWalletConnected,
};

export default ContractUtils;
